import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '@/common/style/global.css'
import * as util from '@/common/js/utils';
import { message } from 'antd';
import * as validate from '@/common/js/validate';
import config from '@/config';
import Router from '@/router';
import headSty from '@/common/js/tbHeadSty';
import reportWebVitals from './reportWebVitals';
// import reportWebVitals from './reportWebVitals';
React.$util = util;
React.$validate = validate;
React.$message = message;
React.$config = config;
React.$headSty = headSty;

React.$socket = null
React.$audio = null
React.$socketInterval = undefined

ReactDOM.render(
        <Router />,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
